import React from 'react';
import { Link } from 'react-router-dom';
import './styles.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content container">

        {/* Brand Column */}
        <div className="footer-col brand-col">
          <h2 className="logo">NextGen</h2>
          <p className="tagline">
            Your go-to destination for smart tech, <br/>lifestyle products & more. Fast shipping. Trusted by thousands.
          </p>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook"></i></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-youtube-play" /></a>
          </div>
        </div>

        {/* Shop Links */}
        <div className="footer-col">
          <h4>Shop</h4>
          <ul>
            <li><Link to="/shop">All Products</Link></li>
            <li><Link to="/categories">Categories</Link></li>
            <li><Link to="/new-arrivals">New Arrivals</Link></li>
            <li><Link to="/best-sellers">Best Sellers</Link></li>
          </ul>
        </div>

        {/* Support Links */}
        {/* <div className="footer-col">
          <h4>Support</h4>
          <ul>
            <li><Link to="/faq">FAQs</Link></li>
            <li><Link to="/returns">Return Policy</Link></li>
            <li><Link to="/track-order">Track Order</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div> */}

        {/* Newsletter */}
        <div className="footer-col newsletter-col">
          <h4>Stay in the loop</h4>
          <p>Get special offers, updates, and news straight to your inbox.</p>
          <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
            <input type="email" placeholder="Your email" />
            <button type="submit">Subscribe</button>
          </form>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} NextGen Inc. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
